export default __webpack_public_path__ + "static/media/GearCampus1.cddf7bfa.jpg";